var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('sys-pop-over-config-base',{attrs:{"model":_vm.model,"configs":_vm.configs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }